<!--
Le bloc ci-dessous nous offre le bindig angular et sa gestion d'événement.
Problème : Il faut répéter deux fois l'ajout du p-schedule
-->
@if (isManager()) {
  <p-tabs (valueChange)="onTabChange($event)" [value]="0">
    <p-tablist>
      <p-tab [value]="0">My events</p-tab>
      <p-tab [value]="1">Overview</p-tab>
      @if (isAdmin()) {
        <p-tab [value]="2">Management</p-tab>
      }
    </p-tablist>
    <p-tabpanels>
      <p-tabpanel [value]="0">
        <calendarComponent></calendarComponent>
      </p-tabpanel>
      <p-tabpanel [value]="1">
        <overview [displayedAsTab]="displayedTab==1"></overview>
      </p-tabpanel>
      @if (isAdmin()) {
        <p-tabpanel [value]="2">
          @if (pendingEvents.length == 0) {
            <div>
              <p class="margin-top-15-sm">There is no pending event.</p>
            </div>
          }
          <div id="list-event-pending" class="list-group">
            @for (event of pendingEvents; track event) {
              <div class="list-group-item-container">
                <div class="list-group-item">
                  <div class="row-picture">
                    <div class="avatar-icon" [ngClass]="getStyleForAvatar(event.eventUser.userName)">{{event.eventUser.userLogin | trigrammePipe}}</div>
                  </div>
                  <div class="row-content">
                    <div class="list-group-item-heading-2el">
                      <p><span class="list-group-item-heading">{{event.eventUser.userFirstName}} {{event.eventUser.userName}}</span>&nbsp;</p>
                      <p>{{getLabelForRequest(event.eventStatus)}} <span [ngClass]="getStyleForRequest(event.eventType)">{{getEventLabel(event.eventType)}}</span></p>
                    </div>
                    <div class="list-group-item-text">
                      <div class="container-fluid">
                        @if (event.eventDesc) {
                          <div class="row">
                            <div class="col-md-12 list-group-item-desc">
                              <p style="margin-right: 10px"><i class="material-icons">&#xE88E;</i></p>
                              <p class="list-group-item-event-msg">{{event.eventDesc}}</p>
                            </div>
                          </div>
                        }
                        <div class="row">
                          <div class="col-md-12 list-group-item-periods">
                            <p style="margin-right: 10px"><i class="material-icons">&#xE192;</i></p>
                            <p>From <span style="font-weight: 500">{{event.eventStartDate | date:'EEE d MMMM y'}}</span>@if (event.eventStartPeriod=='PM') {
                            <span
                            style="font-weight: 500"> [{{event.eventStartPeriod}}]</span>
                          }&nbsp;</p>
                          <p>&nbsp;to&nbsp;<span style="font-weight: 500">{{event.eventEndDate | date:'EEE d MMMM y'}}</span>@if (event.eventEndPeriod=='AM') {
                          <span
                          style="font-weight: 500"> [{{event.eventEndPeriod}}]</span>
                          }&nbsp;
                          @if (event.nbDaysOff < 2) {
                            <span>&nbsp;({{event.nbDaysOff}} day)</span>
                          }
                          @if (event.nbDaysOff>=2) {
                            <span>&nbsp;({{event.nbDaysOff}} days)</span>
                          }</p>
                        </div>
                      </div>
                      @if (event.eventUpdDesc) {
                        <div class="row">
                          <div class="col-md-12 list-group-item-desc">
                            <p style="margin-right: 10px"><i class="material-icons">&#xE0B9;</i></p>
                            <p class="list-group-item-event-msg">{{event.eventUpdDesc}}</p>
                          </div>
                        </div>
                      }
                      @if (isPastEvent(event.eventStartDate)) {
                        <div class="row">
                          <div class="col-md-12 list-group-item-desc">
                            <p style="margin-right: 10px"><i class="material-icons danger">&#xE002;</i></p>
                            <p class="list-group-item-event-msg danger">Past event</p>
                          </div>
                        </div>
                      }
                      <div class="row">
                        <div class="col-md-12 list-group-item-actions">
                          @if (event.eventStatus=='CORRECTED' ||  event.eventStatus=='DEL_REQUESTED' || isPastEvent(event.eventStartDate)) {
                            <a class="nohref btn-fab">
                              <i class="material-icons danger">&#xE002;</i>
                            </a>
                          }
                          <a class="btn btn-success-custom btn-fab btn-fab-mini" title="Accept" (click)="manageEvent('VALIDATED', event.eventId)"><i class="material-icons">&#xE5CA;</i></a>
                          <a class="btn btn-danger-custom btn-fab btn-fab-mini" title="Reject" (click)="manageEvent('REFUSED', event.eventId)"><i class="material-icons">&#xE92B;</i></a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="list-group-separator"></div>
            </div>
          }
        </div>
      </p-tabpanel>
    }
  </p-tabpanels>
</p-tabs>
}

@if (!isManager()) {
  <div>
    <calendarComponent></calendarComponent>
  </div>
}
<justification-modal [(open)]="justificationModalOpened" [currentEvent]=currentEvent title={{justificationModalTitle}} (closeModal)="handleCloseEvent($event)"></justification-modal>
